import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { MessageService } from "primeng/api";
import { isNotAuthorizationExpiryError } from "./util/common.util";
import { endpoints } from "../environments/endpoints";
import { HttpMethod, TEXTS } from "./constants/common.constants";

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const url = req.url;
        const method = req.method;
        const apiError = error?.error;

        if (isNotAuthorizationExpiryError(apiError)) {
          if (method == HttpMethod.POST) {
            if (url?.includes(endpoints.notifications)) {
              this.showSuccessErrorToast(
                apiError?.message ||
                  TEXTS.getAllNotificationsForProvidedCriteriaApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.updateNotifications)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.errorMessageNotifications,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.filtersCodesetLookup)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.filterCodeSetApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.filters)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.saveFiltersApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.downloadCSV)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.notificationDownloadApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.comments)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.addCommentApiErrorMessage,
                "error",
                "Error"
              );
            } else {
              // generic block to handle error for api's not registered here
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.defaultApiErrorMessage,
                "error",
                "Error"
              );
            }
          }
          if (method == HttpMethod.GET) {
            if (url?.includes(endpoints.notifications)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.notificationGetByIdApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.getNotificationsHasUpdate)) {
              this.showSuccessErrorToast(
                apiError?.message ||
                  TEXTS.notificationHasUpdatesApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.userSettings)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.getUserSettingsApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.filters)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.getFiltersApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.defaultFilter)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.getDefaultFilterApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.logout)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.logoutApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.comments)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.getCommentsApiErrorMessage,
                "error",
                "Error"
              );
            } else {
              // generic block to handle error for api's not registered here
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.defaultApiErrorMessage,
                "error",
                "Error"
              );
            }
          }
          if (method == HttpMethod.DELETE) {
            if (
              method == HttpMethod.DELETE &&
              url?.includes(endpoints.removeNotificationFromUserView)
            ) {
              this.showSuccessErrorToast(
                apiError?.message ||
                  TEXTS.removeNotificationFromUserViewApiErrorMessage,
                "error",
                "Error"
              );
            } else if (
              method == HttpMethod.DELETE &&
              url?.includes(endpoints.defaultFilter)
            ) {
              this.showSuccessErrorToast(apiError?.message, "error", "Error");
            } else if (
              method == HttpMethod.DELETE &&
              url?.includes(endpoints.comments)
            ) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.deleteCommentApiErrorMessage,
                "error",
                "Error"
              );
            } else {
              // generic block to handle error for api's not registered here
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.defaultApiErrorMessage,
                "error",
                "Error"
              );
            }
          }
          if (method == HttpMethod.PATCH) {
            if (url?.includes(endpoints.updateNotificationReadUnread)) {
              this.showSuccessErrorToast(
                apiError?.message ||
                  TEXTS.notificationReadUnreadApiErrorMessage,
                "error",
                "Error"
              );
            } else if (
              url?.includes(endpoints.notifications) &&
              url?.includes("/status")
            ) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.notificationStatusApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.defaultFilter)) {
              this.showSuccessErrorToast(apiError?.message, "error", "Error");
            } else {
              // generic block to handle error for api's not registered here
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.defaultApiErrorMessage,
                "error",
                "Error"
              );
            }
          }
          if (method == HttpMethod.PUT) {
            if (url?.includes(endpoints.userSettings)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.updateUserSettingsApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.filters)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.saveFiltersApiErrorMessage,
                "error",
                "Error"
              );
            } else if (url?.includes(endpoints.comments)) {
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.updateCommentApiErrorMessage,
                "error",
                "Error"
              );
            } else {
              // generic block to handle error for api's not registered here
              this.showSuccessErrorToast(
                apiError?.message || TEXTS.defaultApiErrorMessage,
                "error",
                "Error"
              );
            }
          }
        }
        console.error(error);

        return throwError(() => error);
      })
    );
  }

  showSuccessErrorToast(errorMessage: any, serverity: any, summary: any) {
    this.messageService.add({
      severity: serverity,
      summary: summary,
      detail: errorMessage,
    });
  }
}
